import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdGlobalProductsSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalProductsSettings.tsx';
import ErrorPagesNotFound from '@jira/router-routes__common/src/ui/error-pages/not-found/index.tsx';
import { navigationSidebarGlobalResource } from '@jira/router-resources__navigation-sidebar-global/src/navigationSidebarGlobalResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { conditionalPostOfficeJiraTopBannerResource } from '@jira/router-resources__post-office/src/conditionalPostOfficeJiraTopBannerResource.tsx';
import type { Route } from '@atlassian/react-resource-router';
import HealthcheckPage from '@jira/applinks__extra-auth/src/HealthcheckPage.tsx';
import { applinksExtraAuthHealthcheckRoute } from '@jira/router-routes__admin-pages-applinks-routes/src/applinksExtraAuthHealthcheckRoute.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { componentWithFG } from '@jira/platform__utils-feature-gates-gate-component/src/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';

export const applinksExtraAuthHealthcheckRouteEntry: Route = createEntry(
	applinksExtraAuthHealthcheckRoute,
	() => ({
		group: 'global-settings',
		ufoName: 'applinks-extra-auth-healthcheck',

		// eslint-disable-next-line no-restricted-syntax
		component: componentWithFG(
			'applinks-789-extra-auth-healthcheck-frontend',
			HealthcheckPage,
			ErrorPagesNotFound,
		),

		layout: globalSettingsLayout,

		navigation: {
			sidebarId: SidebarIdGlobalProductsSettings,
			menuId: MenuIdSettings,
		},

		resources: [
			...getNavigationResources(),
			navigationSidebarGlobalResource,
			conditionalPostOfficeJiraTopBannerResource,
		],

		canTransitionIn: () => fg('applinks-789-extra-auth-healthcheck-frontend'),
		forPaint: [LazyAtlassianNavigation],

		meta: {
			reporting: {
				id: 'Applinks',
				packageName: 'jiraAdminPagesApplinks',
				teamName: 'olympus',
			},
		},

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
